export class Sprite_MapInventoryStatText extends KDCore.Sprite {
  constructor(statId, cell) {
    super();
    this.statId = statId;
    this.cell = cell;
    this._create();
  }

  isOnlyleader() {
    return $gameParty.allMembers().length === 1;
  }

  isEquipped() {
    return this.cell._isEquipedItem && this.cell._inSpecialState;
  }

  getColorHex(colorType) {
    switch (colorType) {
      case 'normal':
        return KDCore.Color.FromHex(this.settings.EquipmentStats.statTextColor).CSS;
      case 'lower':
        return KDCore.Color.FromHex(this.settings.EquipmentStats.statLowerColor).CSS;
      case 'hight':
        return KDCore.Color.FromHex(this.settings.EquipmentStats.statHightColor).CSS;
      default:
        return KDCore.Color.WHITE.CSS;
    }
  }

  paramValueId() {
    switch (this.statId) {
      case 'atk':
        return 2;
      case 'def':
        return 3;
      case 'mat':
        return 4;
      case 'mdf':
        return 5;
      case 'agi':
        return 6;
      case 'luk':
        return 7;
      default:
        return -1;
    }
  }

  _create() {
    this._loadSettings();
    this._createContent();
    this._drawValues();
  }

  _loadSettings() {
    this.settings = this._settingsJSON();
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  _createContent() {
    this.baseTextLine = KDCore.Sprite.FromTextSettings(this.settings.EquipmentStats.statText);
    this.addChild(this.baseTextLine);
  }

  _drawValues() {
    return this._drawStateValueForActor($gameParty.leader());
  }

  _drawStateValueForActor(actor) {
    if (this.isEquipped()) {
      if (YsServices.equipmentService.get_AllowFullStats()) {
        return this._drawStateValue(actor[this.statId], 'normal');
      } else {
        return this._drawEquipValue();
      }
    } else {
      return this._drawStateDiffValue(actor);
    }
  }

  _drawStateValue(value, colorType) {
    this.baseTextLine.b().textColor = this.getColorHex(colorType);
    return this.baseTextLine.drawTextFull(value, 'center');
  }

  _drawEquipValue() {
    let value;
    const paramId = this.paramValueId();

    if (paramId >= 0) {
      value = this.cell.item.params[paramId];
    } else {
      value = 0;
    }

    let type = 'normal';
    if (value < 0) {
      type = 'lower';
    } else if (value > 0) {
      type = 'hight';
      value = "+" + value;
    }

    this.baseTextLine.b().textColor = this.getColorHex(type);
    this.baseTextLine.drawTextFull(value, 'center');
  }

  _drawStateDiffValue(actor) {
    var actorCurrentParam, actorParamBase, eq, equippedValue, newValue, paramId, paramValue, t, type;
    paramId = this.paramValueId();
    if (paramId >= 0) {
      paramValue = this.cell.item.params[paramId];
    } else {
      paramValue = 0;
    }
    eq = this._equipedOne(actor, this.cell.item);
    if (eq != null) {
      equippedValue = eq.params[paramId];
    } else {
      equippedValue = 0;
    }
    actorParamBase = actor[this.statId] - equippedValue;
    actorCurrentParam = actor[this.statId];
    newValue = actorParamBase + paramValue;
    if (newValue === actorCurrentParam) {
      type = 'normal';
    } else if (newValue > actorCurrentParam) {
      type = 'hight';
    } else {
      type = 'lower';
    }
    if (type === 'normal') {
      this._drawStateValue(newValue, 'normal');
    } else {
      t = "";
      if (type === 'lower') {
        t = newValue + "(-" + (actorCurrentParam - newValue) + ")";
      } else {
        t = newValue + "(+" + (newValue - actorCurrentParam) + ")";
      }
      this.baseTextLine.b().textColor = this.getColorHex(type);
      this.baseTextLine.drawTextFull(t, 'center');
    }
  }

  _equipedOne(actor, item) {
    item = actor.equips()[item.etypeId - 1];
    return item;
  }
}
